import React, { useEffect, useState } from "react";
import { Button, Card, CircularProgress, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, TextField } from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import { connect } from "react-redux";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";
import { districtCreate, districtCreateErrorClear, getStateOptionCreate } from "store/app/form-management/district-configuration/actions";
import { AllowedSpecialCharacters, AllowedSpecialCharactersPaste } from "helper/regex";
import VWDropdown from "components/dropdown";
import { unionBy } from 'lodash';

const CreateDistrict = (props) => {

    const { open, filter, paginationData, errorMessage, onClose, isPending } = props;
    const { selectedStateId, selectedState } = props;

    const [districtData, setDistrictData] = useState();
    const [errors, setErrors] = useState({});

    //--------------------State---------------------------
    const [stateOptions, setStateOptions] = useState([]);
    const [state, setState] = useState();

    const loadStateOption = (filter, page, pageSize) => {
        return props.getStateOption(filter, page, pageSize)
    }

    const handleStateSelect = (option) => {
        const { label, value } = option || {};
        setState(option);
        setDistrictData({
            ...districtData,
            stateName: label,
            stateId: value
        })
        setErrors({
            ...errors,
            stateName: null,
        })
    }

    useEffect(() => {
        props.districtCreateErrorClear();
        setErrors({});

        if (selectedState && selectedStateId) {
            setDistrictData({
                stateName: selectedState,
                stateId: selectedStateId
            });
            setState({ label: selectedState, value: selectedStateId })
        }
        else {
            setDistrictData();
            setState();
        }
    }, [open])

    const validateOnchange = (e) => {
        const { name, value } = e.target;

        setDistrictData({
            ...districtData,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const handleDistrictCreate = (e) => {
        e.preventDefault();

        const { district, stateName } = districtData || {};
        const currentErrors = {};

        if (!district && !district?.trim()) {
            currentErrors.district = 'District name is required';
        }
        if (!stateName && !stateName?.trim()) {
            currentErrors.stateName = 'State/Export name is required';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.districtCreate(districtData, filter, paginationData);
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Create District
                                <IconButton aria-label="close" onClick={onClose}>
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form>
                                    <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                        <Grid item >
                                            <TextField
                                                label={<div >District Name <Required /></div>}
                                                sx={{ mt: 1 }}
                                                fullWidth
                                                autoFocus
                                                autoComplete="off"
                                                size="small"
                                                name='district'
                                                type='text'
                                                onChange={validateOnchange}
                                                onPaste={AllowedSpecialCharactersPaste}
                                                onKeyDown={AllowedSpecialCharacters}
                                                error={errors?.district}
                                                helperText={errors?.district}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <VWDropdown
                                                label="State/Export Name"
                                                name="stateName"
                                                multiple={false}
                                                // disablePortal={true}
                                                getOptions={loadStateOption}
                                                onSelect={handleStateSelect}
                                                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                selectedOption={selectedState ? selectedState : state}
                                                options={stateOptions}
                                                setOptions={(options) => {
                                                    setStateOptions((prev) => unionBy(prev, options, "value"));
                                                }}
                                                isRequired={true}
                                                error={errors?.stateName}
                                                isDisabled={selectedState || false}
                                            />
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleDistrictCreate}
                                                size="small"
                                                color="primary"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.districts.isDistrictCreatePending,
    errorMessage: state.districts.districtCreateErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    districtCreate: (formData, filter, paginationData) => dispatch(districtCreate(formData, filter, paginationData)),
    districtCreateErrorClear: () => dispatch(districtCreateErrorClear()),
    getStateOption: (filter, page, pageSize) => dispatch(getStateOptionCreate(filter, page, pageSize)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateDistrict);